import { createWebHistory, createRouter } from "vue-router";
import { nextTick } from "vue";
import routes from "./routes";

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  nextTick(() => {
    const allElements = document.querySelectorAll('*');

    allElements.forEach(el => {
      if (el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth) {
        el.scrollTo(0, 0);
      }
    });

    window.scrollTo(0, 0);
  });

  if (to.name === "TradingView") {
    const lowerCaseParams = {
      exchange: to.params.exchange.toLowerCase(),
      coin: to.params.coin.toLowerCase(),
      quote: to.params.quote.toLowerCase(),
    };

    if (
      to.params.exchange !== lowerCaseParams.exchange ||
      to.params.coin !== lowerCaseParams.coin ||
      to.params.quote !== lowerCaseParams.quote
    ) {
      next({ name: "TradingView", params: lowerCaseParams });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;